import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=021e1bb6&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=021e1bb6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021e1bb6",
  null
  
)

export default component.exports